import { Box, BoxProps } from '@mui/material';

export const PageLayout = ({ children, sx, ...rest }: BoxProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export const PageContent = ({ children, sx, ...rest }: BoxProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        py: {
          xs: 2,
          sm: 4,
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};
